import axios from 'axios'
import { Loading } from 'element-ui'
// import _ from 'lodash'
// import SwalAlert from 'utils/SwalAlert'
// import httpConfig from './http_config'

var http = axios.create({
  baseURL: window.location.protocol+'//' + window.location.host, // 设置请求的base url
  // baseURL: '/api', // 设置请求的base url
  // baseURL: httpConfig.DOMIN,
  // timeout: 15000, // 超时时长
  headers: {'content-type': 'application/json;charset=UTF-8'},
})
// 覆写库的超时默认值
// http.defaults.timeout = 2500;
// 为已知需要花费很长时间的请求覆写超时设置
export var http1 = axios.create({
  baseURL: window.location.protocol+'//' + window.location.host, // 设置请求的base url
  headers: {'content-type': 'application/json;charset=UTF-8'},
})
let loading // loading对象
let needLoadingRequestCount = 0 // 当前正在请求的数量
window._axiosPromiseArr = [] // axios中设置放置要取消的对象
// 显示loading
function showLoading (target) {
  // 后面这个判断很重要,因为关闭时加了抖动,此时loading对象可能还存在,但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(255, 255, 255, 0.5)',
      // target: target || 'body'
      target: document.querySelector('.loadingPrivate')
    })
  }
  needLoadingRequestCount++
}
// 隐藏loading
function hideLoading () {
  needLoadingRequestCount--
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0) // 做个保护
  if (needLoadingRequestCount === 0) {
    loading.close()
    loading = null
    // 关闭loading
    // toHideLoading()
  }
}
// 防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
// var toHideLoading = _.debounce(() => {
//   loading.close()
//   loading = null
// }, 300)
// 添加请求拦截器
http.interceptors.request.use(config => {
  // 判断当前请求是否设置了不显示Loading
  if (config.headers.showLoading !== false) {
    showLoading(config.headers.loadingTarget)
  }
  if (needLoadingRequestCount >= 10) { // 同时队列中可以缓存的最大链接数量
    hideLoading()
    // SwalAlert.warning('请求的内容过多，请稍后再试！')
    return false
  }
  //监听路由，在路由切换前将上个页面的请求取消
  config.cancelToken = new axios.CancelToken(cancel => {
    window._axiosPromiseArr.push({ cancel })
  })
  return config
}, err => {
  // 判断当前请求是否设置了不显示Loading
  if (err.headers.showLoading !== false) {
    hideLoading()
  }
  // SwalAlert.error('请求超时!')
  return Promise.resolve(err)
})
http1.interceptors.request.use(config => {
  // 判断当前请求是否设置了不显示Loading
  if (config.headers.showLoading !== false) {
    showLoading(config.headers.loadingTarget)
  }
  if (needLoadingRequestCount >= 10) { // 同时队列中可以缓存的最大链接数量
    hideLoading()
    // SwalAlert.warning('请求的内容过多，请稍后再试！')
    return false
  }
  //监听路由，在路由切换前将上个页面的请求取消
  config.cancelToken = new axios.CancelToken(cancel => {
    window._axiosPromiseArr.push({ cancel })
  })
  return config
}, err => {
  // 判断当前请求是否设置了不显示Loading
  if (err.headers.showLoading !== false) {
    hideLoading()
  }
  // SwalAlert.error('请求超时!')
  return Promise.resolve(err)
})
// 响应拦截器
http.interceptors.response.use(
  response => {
    // 判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (response.config.headers.showLoading !== false) {
      hideLoading()
    }
    if (response.data.code == '99999') {
      // token过期返回登录页
      // if(response.data.data.code=='88886'){
      //   this.$router.push({
      //     path:"/login"
      //   })
      // }
    }
    return response
  },
  error => {
    // 判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (error.config.headers.showLoading !== false) {
      hideLoading()
    }
    // if (error.response && error.response.data && error.response.data.message) {
    //   var jsonObj = JSON.parse(error.response.data.message)
    //   SwalAlert.error(jsonObj.message)
    // } else {
    //   SwalAlert.error(error.message)
    // }
    // if (error && error.response) {
    //   switch (error.response.status) {
    //     case 400:
    //       error.message = '错误请求'
    //       break
    //     case 401:
    //       error.message = '未授权，请重新登录'
    //       break
    //     case 403:
    //       error.message = '拒绝访问'
    //       break
    //     case 405:
    //       error.message = '请求超时'
    //       break
    //     case 500:
    //       error.message = '服务端出错'
    //       break
    //     case 501:
    //       error.message = '网络未实现'
    //       break
    //     case 404:
    //       error.message = '错误请求，未找到该资源！'
    //       break
    //     case 12029:
    //       error.message = '您的网络已中断或系统服务器已停止'
    //       break
    //     default:
    //       error.message = `连接错误${error.response.status}`
    //   }
    //   SwalAlert.error(error.message)
    // }
    return Promise.reject(error)
  }
)
http1.interceptors.response.use(
  response => {
    // 判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (response.config.headers.showLoading !== false ) {
      hideLoading()
    }
    return response
  },
  error => {
    // 判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (error.config.headers.showLoading !== false) {
      hideLoading()
    }
    return Promise.reject(error)
  }
)
export default http



// WEBPACK FOOTER //
// ./src/services/http.js